import type { PermissionsMap } from "@/lib/api";

/**
 * Determina la ruta de aterrizaje tras el login según los permisos del
 * usuario. Se evalúa en orden de prioridad — el primer match gana.
 *
 * El dashboard requiere ver informes O cesiones (mismo criterio que el guard
 * de `app/dashboard/page.tsx`). Los roles que no cumplen (p. ej. Personal de
 * Flota Lavadero, que solo ve tareas/vehículos) deben aterrizar en una página
 * a la que sí tengan acceso para no ver "Acceso Restringido".
 */
export function getLandingRoute(permissions: PermissionsMap | undefined): string {
  if (!permissions) return "/dashboard";
  const can = (feature: string) => !!permissions[feature]?.canView;

  // Dashboard = vista de informes/KPIs (gateado por `reports`).
  if (can("reports")) return "/dashboard";
  // Roles operativos sin acceso al dashboard:
  if (can("scheduled-tasks")) return "/tasks";
  if (can("calendar-events")) return "/calendar";
  if (can("assignments")) return "/assignments";
  if (can("vehicles")) return "/vehicles";
  return "/dashboard";
}

/**
 * Ruta a la que volver tras ejecutar una entrega o devolución.
 * Administrador (acceso a informes) → calendario; Personal de Flota
 * (sin informes pero con tareas) → vista de tareas; cualquier otro rol →
 * `fallback` (normalmente el detalle de la cesión).
 */
export function getPostExecutionRoute(
  permissions: PermissionsMap | undefined,
  fallback: string,
): string {
  if (!permissions) return fallback;
  const can = (feature: string) => !!permissions[feature]?.canView;
  if (can("reports")) return "/calendar";
  if (can("scheduled-tasks")) return "/tasks";
  return fallback;
}
